import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  gerarBoletoTeorico (dados) {
    return new Promise((resolve, reject) => {
      Vue.http.post(urlApi + '/boletos/boleto/teorico', dados).then(function (response) {
        // console.log(response);
        resolve(response.data)
      })
    })
  },

  gerarBoletoTeorico_pagSeguro (dados) {
    return new Promise((resolve, reject) => {
      Vue.http.get(urlApi + '/boletos/sessao').then(function (response) {
        let sessao = response.data.dados.id
        PagSeguroDirectPayment.setSessionId(sessao)

        // PagSeguroDirectPayment.getPaymentMethods({
        //   amount: 37.50,
        //   success: function(response) {
        //     console.log('TESTE1')
        //     console.log(response)
        //   },
        //   error: function(response) {
        //     console.log('TESTE2')
        //     console.log(response)
        //   },
        //   complete: function(response) {

        //   }
        // });

        PagSeguroDirectPayment.onSenderHashReady(function (response) {
          if (response.status == 'error') {
            console.log(response.message)
            this.launchToast('fa-exclamation', response.message)
            reject(response.message)
          } else {
            let data = {
              senderHash: response.senderHash,
              boletos: dados
            }

            Vue.http.post(urlApi + '/boletos/boleto/teorico', data).then(function (response) {
              // console.log(response);
              resolve(response.data)
            })
          }
        })
      })
    })
  },

  gerarBoletoPratico (dados) {
    return new Promise((resolve, reject) => {
      Vue.http.get(urlApi + '/boletos/sessao')
        .then(function (response) {
          let sessao = response.data.dados.id
          PagSeguroDirectPayment.setSessionId(sessao)

          // PagSeguroDirectPayment.getPaymentMethods({
          //   amount: 37.50,
          //   success: function(response) {
          //     console.log('TESTE1')
          //     console.log(response)
          //   },
          //   error: function(response) {
          //     console.log('TESTE2')
          //     console.log(response)
          //   },
          //   complete: function(response) {

          //   }
          // });

          PagSeguroDirectPayment.onSenderHashReady(function (response) {
            if (response.status == 'error') {
              console.log(response.message)
              reject(response.message)
            } else {
              let data = {
                senderHash: response.senderHash,
                boletos: dados
              }

              Vue.http.post(urlApi + '/boletos/boleto/pratico', data).then(function (response) {
                resolve(response.data.dados[0])
              })
            }
          })
        })
    })
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  }

}
